/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('@/layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'inicio',
          component: () => import('@/views/Home.vue'),
          meta: {
            breadcrumb: [{ title: 'Inicio', url: '/' }],
            pageTitle: 'Inicio',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/dashboard/anuncios',
          name: 'anuncios',
          component: () => import('@/views/dashboard/Anuncios.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Dashboard', url: '/dashboard/anuncios' },
              { title: 'Anuncios', active: true }
            ],
            pageTitle: 'ANUNCIOS',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/dashboard/documentacion',
          name: 'documentacion',
          component: () => import('@/views/dashboard/documentacion/Documentacion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Documentación', url: '/dashboard/documentacion' },              
              { title: 'Documentación', active: true }
            ],
            pageTitle: 'Documentación',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/usuarios/perfil/:userId',
          name: 'perfil',
          component: () => import('@/views/administracion/user/UserProfileEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Usuarios', url: '/' },
              { title: 'Perfil del usuario', active: true }
            ],
            pageTitle: 'Perfil del usuario',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/administracion/usuarios',
          name: 'usuarios',
          component: () => import('@/views/administracion/user/user-list/UserList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Administración', url: '/administracion/usuarios' },
              { title: 'Usuarios', url: '/administracion/usuarios' },
              { title: 'Lista de usuarios', active: true }
            ],
            pageTitle: 'Usuarios',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/administracion/usuarios/ver/:userId',
          name: 'usuariosVer',
          component: () => import('@/views/administracion/user/UserView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Administración', url: '/administracion/usuarios' },
              { title: 'Usuarios', url: '/administracion/usuarios' },
              { title: 'Ver usuario', active: true }
            ],
            pageTitle: 'Ver usuario',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/administracion/usuarios/nuevo',
          name: 'usuariosNuevo',
          component: () => import('@/views/administracion/user/UserNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Administración', url: '/administracion/usuarios' },
              { title: 'Usuarios', url: '/administracion/usuarios' },
              { title: 'Nuevo usuario', active: true }
            ],
            pageTitle: 'Nuevo usuario',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/administracion/usuarios/editar/:userId',
          name: 'usuariosEditar',
          component: () => import('@/views/administracion/user/UserEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Administración', url: '/administracion/usuarios' },
              { title: 'Usuarios', url: '/administracion/usuarios' },
              { title: 'Editar usuario', active: true }
            ],
            pageTitle: 'Editar usuario',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/empresas',
          name: 'empresas',
          component: () => import('@/views/configuracion/empresas/EmpresasList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/empresas' },
              { title: 'Empresas', url: '/configuracion/empresas' },
              { title: 'Lista de empresas', active: true }
            ],
            pageTitle: 'Empresas',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/empresas/nueva',
          name: 'empresasNueva',
          component: () => import('@/views/configuracion/empresas/EmpresasNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/empresas' },
              { title: 'Empresas', url: '/configuracion/empresas' },
              { title: 'Nueva empresa', active: true }
            ],
            pageTitle: 'Nueva empresa',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/empresas/ver/:empresaId',
          name: 'empresasVer',
          component: () => import('@/views/configuracion/empresas/EmpresasView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/empresas' },
              { title: 'Empresas', url: '/configuracion/empresas' },
              { title: 'Ver empresa', active: true }
            ],
            pageTitle: 'Ver empresa',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/empresas/editar/:empresaId',
          name: 'empresasEditar',
          component: () => import('@/views/configuracion/empresas/EmpresasEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/empresas' },
              { title: 'Empresas', url: '/configuracion/empresas' },
              { title: 'Editar empresa', active: true }
            ],
            pageTitle: 'Editar empresa',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-sectores',
          name: 'valSectores',
          component: () => import('@/views/configuracion/val-sectores/ValSectoresList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-sectores' },
              { title: 'Sectores', url: '/configuracion/val-sectores' },
              { title: 'Lista de sectores', active: true }
            ],
            pageTitle: 'Sectores',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-sectores/nuevo',
          name: 'valSectoresNuevo',
          component: () => import('@/views/configuracion/val-sectores/ValSectoresNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-sectores' },
              { title: 'Sectores', url: '/configuracion/val-sectores' },
              { title: 'Nuevo sector', active: true }
            ],
            pageTitle: 'Nuevo sector',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-sectores/ver/:sectorId',
          name: 'valSectoresVer',
          component: () => import('@/views/configuracion/val-sectores/ValSectoresView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-sectores' },
              { title: 'Sectores', url: '/configuracion/val-sectores' },
              { title: 'Ver sector', active: true }
            ],
            pageTitle: 'Ver sector',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-sectores/editar/:sectorId',
          name: 'valSectoresEditar',
          component: () => import('@/views/configuracion/val-sectores/ValSectoresEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-sectores' },
              { title: 'Sectores', url: '/configuracion/val-sectores' },
              { title: 'Editar sector', active: true }
            ],
            pageTitle: 'Editar sector',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-productos',
          name: 'valProductos',
          component: () => import('@/views/configuracion/val-productos/ValProductosList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-productos' },
              { title: 'Productos', url: '/configuracion/val-productos' },
              { title: 'Lista de productos', active: true }
            ],
            pageTitle: 'Productos',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-productos/nuevo',
          name: 'valProductosNuevo',
          component: () => import('@/views/configuracion/val-productos/ValProductosNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-productos' },
              { title: 'Productos', url: '/configuracion/val-productos' },
              { title: 'Nuevo producto', active: true }
            ],
            pageTitle: 'Nuevo producto',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-productos/ver/:productoId',
          name: 'valProductosVer',
          component: () => import('@/views/configuracion/val-productos/ValProductosView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-productos' },
              { title: 'Productos', url: '/configuracion/val-productos' },
              { title: 'Ver producto', active: true }
            ],
            pageTitle: 'Ver producto',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-productos/editar/:productoId',
          name: 'valProductosEditar',
          component: () => import('@/views/configuracion/val-productos/ValProductosEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-productos' },
              { title: 'Productos', url: '/configuracion/val-productos' },
              { title: 'Editar producto', active: true }
            ],
            pageTitle: 'Editar producto',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/importar-val-productos',
          name: 'importarValProductos',
          component: () => import('@/views/configuracion/val-productos/ImportarValProductos.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/importar-val-productos' },
              { title: 'Productos', url: '/configuracion/importar-val-productos' },
              { title: 'Importar productos', active: true }
            ],
            pageTitle: 'Importar productos',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-tipos-documentos',
          name: 'valTiposDocumentos',
          component: () => import('@/views/configuracion/val-tipos-documentos/ValTiposDocumentosList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-tipos-documentos' },
              { title: 'Tipos de documentos', url: '/configuracion/val-tipos-documentos' },
              { title: 'Lista de tipos de documentos', active: true }
            ],
            pageTitle: 'Tipos de documentos',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-tipos-documentos/nuevo',
          name: 'valTiposDocumentosNuevo',
          component: () => import('@/views/configuracion/val-tipos-documentos/ValTiposDocumentosNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-tipos-documentos' },
              { title: 'Tipos de documentos', url: '/configuracion/val-tipos-documentos' },
              { title: 'Nuevo tipo de documento', active: true }
            ],
            pageTitle: 'Nuevo tipo de documento',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-tipos-documentos/ver/:tipoDocumentoId',
          name: 'valTiposDocumentosVer',
          component: () => import('@/views/configuracion/val-tipos-documentos/ValTiposDocumentosView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-tipos-documentos' },
              { title: 'Tipos de documentos', url: '/configuracion/val-tipos-documentos' },
              { title: 'Ver tipo de documento', active: true }
            ],
            pageTitle: 'Ver tipo de documento',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/val-tipos-documentos/editar/:tipoDocumentoId',
          name: 'valTiposDocumentosEditar',
          component: () => import('@/views/configuracion/val-tipos-documentos/ValTiposDocumentosEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/val-tipos-documentos' },
              { title: 'Tipos de documentos', url: '/configuracion/val-tipos-documentos' },
              { title: 'Editar tipo de documento', active: true }
            ],
            pageTitle: 'Editar tipo de documento',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/anuncios',
          name: 'fotos-de-anuncios',
          component: () => import('@/views/configuracion/anuncios/Anuncios.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestión', url: '/configuracion/anuncios' },              
              { title: 'Subir anuncios', active: true }
            ],
            pageTitle: 'Anuncios',
            rule: 'ROLE_ADMIN'
          }
        },
        {
          path: '/configuracion/documentacion',
          name: 'subir-documentacion',
          component: () => import('@/views/configuracion/documentacion/Documentacion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Configuración', url: '/configuracion/documentacion' },              
              { title: 'Subir documentacion', active: true }
            ],
            pageTitle: 'Documentacion',
            rule: 'ROLE_ADMIN'
          }
        },        
        {
          path: '/gestion/presupuestos',
          name: 'presupuestos',
          component: () => import('@/views/gestion/presupuestos/PresupuestoNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestión', url: '/gestion/presupuestos' },
              { title: 'Presupuesto', active: true }
            ],
            pageTitle: 'Presupuesto',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/operaciones',
          name: 'operaciones',
          component: () => import('@/views/gestion/operaciones/OperacionesList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestión', url: '/gestion/operaciones' },
              { title: 'Operaciones', active: true }
            ],
            pageTitle: 'Operaciones',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/operaciones/nueva',
          name: 'operacionesNueva',
          component: () => import('@/views/gestion/operaciones/operaciones-new/OperacionesNew.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestion', url: '/gestion/operaciones' },
              { title: 'Operaciones', url: '/gestion/operaciones' },
              { title: 'Nueva operación', active: true }
            ],
            pageTitle: 'Nueva operación',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/operaciones/editar/:operacionId',
          name: 'operacionesEditar',
          component: () => import('@/views/gestion/operaciones/operaciones-edit/OperacionesEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestion', url: '/gestion/operaciones' },
              { title: 'Operaciones', url: '/gestion/operaciones' },
              { title: 'Editar operación', active: true }
            ],
            pageTitle: 'Editar operación',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/operaciones/ver/:operacionId',
          name: 'operacionesVer',
          component: () => import('@/views/gestion/operaciones/operaciones-view/OperacionesView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestion', url: '/gestion/operaciones' },
              { title: 'Operaciones', url: '/gestion/operaciones' },
              { title: 'Ver operación', active: true }
            ],
            pageTitle: 'Ver operación',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/clientes',
          name: 'clientes',
          component: () => import('@/views/gestion/clientes/ClientesList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestión', url: '/gestion/clientes' },
              { title: 'Clientes', active: true }
            ],
            pageTitle: 'Clientes',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/clientes/editar/:clienteId',
          name: 'clientesEditar',
          component: () => import('@/views/gestion/clientes/clientes-edit/ClientesEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestion', url: '/gestion/clientes' },
              { title: 'Clientes', url: '/gestion/clientes' },
              { title: 'Editar cliente', active: true }
            ],
            pageTitle: 'Editar cliente',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/gestion/clientes/ver/:clienteId',
          name: 'clientesVer',
          component: () => import('@/views/gestion/clientes/clientes-view/ClientesView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Gestion', url: '/gestion/clientes' },
              { title: 'Clientes', url: '/gestion/clientes' },
              { title: 'Ver cliente', active: true }
            ],
            pageTitle: 'Ver cliente',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/informes/comerciales',
          name: 'informesComerciales',
          component: () => import('@/views/informes/comerciales/ComercialesList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Informes', url: '/informes/comerciales' },
              { title: 'Comerciales', active: true }
            ],
            pageTitle: 'Comerciales',
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/informes/comerciales/ver/:comercialId',
          name: 'comercialVer',
          component: () => import('@/views//informes/comerciales/comerciales-view/ComercialesView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/' },
              { title: 'Informes', url: '/informes/comerciales' },
              { title: 'Comerciales', url: '/informes/comerciales' },
              { title: 'Ver comercial', active: true }
            ],
            pageTitle: 'Ver comercial',
            rule: 'ROLE_COMERCIAL'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'ROLE_COMERCIAL'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'ROLE_COMERCIAL'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/pages/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = sessionStorage.getItem('userInfo')

  if (authRequired && !loggedIn) {
    return next('/pages/login')
  }

  next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
